module.exports = __webpack_public_path__ + "static/media/class.eba7bbad.svg";